<template>
    <div class="font-prompt">
        <b-modal :id="modalId"
                 modal-class="modal-success-with-link"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base font-prompt">
                <div class="modal-base-head">
                    <top-bar></top-bar>
                </div>
                <div class="modal-base-body" v-if="configRegisterSuccess">
                    <div class="text-title">{{title}}</div>
                    <div class="icon-wrapper">
                        <div v-if="configRegisterSuccess.btnLeft && !isReward">
                            <div v-if="isDateTimeBetween(configRegisterSuccess.btnLeft.Startime, configRegisterSuccess.btnLeft.Endtime)">
                                <div class="img-icon">
                                    <div @click="openlink(configRegisterSuccess.btnLeft.custom_url, 'click_chanel_website')">
                                        <img :src="getImageUrl(configRegisterSuccess.btnLeft.custom_image_name)" class="w-100"/>
                                    </div>
                                </div>
                                <div class="btn-black mini name" @click="openlink(configRegisterSuccess.btnLeft.custom_url, 'click_chanel_website')">
                                    <div v-html="configRegisterSuccess.btnLeft.custom_name"></div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="img-icon">
                                    <div @click="openlink(configRegisterSuccess.btnLeft.default_url, 'click_chanel_website')">
                                        <img :src="getImageUrl(configRegisterSuccess.btnLeft.default_image_name)" class="w-100"/>
                                    </div>
                                </div>
                                <div class="btn-black mini name" @click="openlink(configRegisterSuccess.btnLeft.default_url, 'click_chanel_website')">
                                    <div v-html="configRegisterSuccess.btnLeft.default_name"></div>
                                </div>
                            </div>

                        </div>
                        <div v-if="configRegisterSuccess.btnCampaign && isReward">
                            <div v-if="isDateTimeBetween(configRegisterSuccess.btnCampaign.Startime, configRegisterSuccess.btnCampaign.Endtime)">
                                <div class="img-icon">
                                    <div @click="openCampaign()">
                                        <img :src="getImageUrl(configRegisterSuccess.btnCampaign.custom_image_name)" class="w-100"/>
                                    </div>
                                </div>
                                <div class="btn-black mini name" @click="openCampaign()">
                                    <div v-html="configRegisterSuccess.btnCampaign.custom_name"></div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="img-icon">
                                    <div @click="openCampaign()">
                                        <img :src="getImageUrl(configRegisterSuccess.btnCampaign.default_image_name)" class="w-100"/>
                                    </div>
                                </div>
                                <div class="btn-black mini name" @click="openCampaign()">
                                    <div v-html="configRegisterSuccess.btnCampaign.default_name"></div>
                                </div>
                            </div>

                        </div>
                        <div v-if="configRegisterSuccess.btnRight">
                            <div v-if="isDateTimeBetween(configRegisterSuccess.btnRight.Startime, configRegisterSuccess.btnRight.Endtime)">
                                <div class="img-icon">
                                    <div @click="openlink(configRegisterSuccess.btnRight.custom_url, 'click_click_search_branch')">
                                        <img :src="getImageUrl(configRegisterSuccess.btnRight.custom_image_name)" class="w-100"/>
                                    </div>
                                </div>
                                <div class="btn-black mini name" @click="openlink(configRegisterSuccess.btnRight.custom_url, 'click_click_search_branch')">
                                    <div v-html="configRegisterSuccess.btnRight.custom_name"></div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="img-icon">
                                    <div @click="openlink(configRegisterSuccess.btnRight.default_url, 'click_click_search_branch')">
                                        <img :src="getImageUrl(configRegisterSuccess.btnRight.default_image_name)" class="w-100"/>
                                    </div>
                                </div>
                                <div class="btn-black mini name" @click="openlink(configRegisterSuccess.btnRight.default_url, 'click_click_search_branch')">
                                    <div v-html="configRegisterSuccess.btnRight.default_name"></div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!-- <div class="row no-gutters px-3">
                        <div class="col-6 pr-1">
                            <div class="img-icon">
                                 <div @click="openlink(configRegisterSuccess.btnLeft.url, 'click_chanel_website')">
                                    <img :src="getImageUrl(configRegisterSuccess.btnLeft.image_name)" class="w-100"/>
                                </div>
                            </div>
                            <div @click="openlink(configRegisterSuccess.btnLeft.url, 'click_chanel_website')" class="btn-black mini">
                                {{configRegisterSuccess.btnLeft.name}}
                            </div>
                        </div>
                        <div class="col-6 pl-1">
                            <div class="img-icon">
                                <div @click="openlink(configRegisterSuccess.btnRight.url, 'click_click_search_branch')">
                                    <img :src="getImageUrl(configRegisterSuccess.btnRight.image_name)" class="w-100"/>
                                </div>
                            </div>
                            <div>
                                <div class="btn-black mini" @click="openlink(configRegisterSuccess.btnRight.url, 'click_click_search_branch')">
                                    {{configRegisterSuccess.btnRight.name}}
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Vue from "vue";
import TopBar from "@/components/TopBar.vue";
import Account from "@/helper/AccountHelper.js";
import { TrackingService } from "@/helper/TrackingHelper.js";
import BzbsApi from "@/service/BzbsApi.js";
import CacheHelper from "@/helper/CacheHelper.js";

export default {
    name: "ModalSuccessWithLink",
    props: {
        busModal: Object,
    },
    components: {
        TopBar,
    },
    data: function() {
        return {
            modalId: 'modal-success-with-link',
            tracking: new TrackingService(this),
            title: "สมัครสมาชิกสำเร็จ",
            Modalconfig: null,
            configRegisterSuccess: null,
            isCustomLeft: false,
            isCustomRight: false,
            isReward: true,
            campaignId: null,
        };
    },
    created: function() {

        this.tracking.screenName("regis_success");
        this.tracking.event("regis_success", "view_regis_success");

        var cache = new CacheHelper('cookie');
        this.isReward = cache.getCache('reward');
    },
    mounted: function() {
        this.busModal.$on('showModal', this.showModal);
        this.busModal.$on('hideModal', this.hideModal);
    },
    methods: {
        showModal: function(text, id) {
            this.getConfigRegisterSuccess()
            console.log("configRegisterSuccess", this.configRegisterSuccess)
            if (text) {

                this.title = text;
            }
            this.campaignId = id;
            this.$bvModal.show(this.modalId);
        },
        hideModal: function() {
            this.$bvModal.hide(this.modalId);
        },
        openlink: function (link, event) {

        this.tracking.event("regis_success", event);
            //alert(link);
            //window.open(link);
            if (Account.getCacheCustom("Formliff")) {

               window.JsFunction.openWeb(link);

            } else {
                window.open(link);
            }
            // window.JsFunction.openWeb(link);
        },
        openCampaign: function () {
            let cache = new CacheHelper('cookie');
            cache.removeCache('reward');
            let path = '/'
            if (this.campaignId) {
                path = '/detail/' + this.campaignId;
            }
            setTimeout(() => {
                this.$router.push(path);
            }, 100);
            // this.$nextTick().then(() => {
            // });


        },
        getConfigRegisterSuccess: function () {

            // const currentTime = new Date().getTime();
			var strUrl = Vue.bzbsConfig.bzbsBlobUrl + "/webconfig/Chanel/config/register_success_config.json";
            console.log("blob strUrl",strUrl)
			return new Promise(() => {
				BzbsApi.connectBzbsGetBlob(strUrl)
                    .then((response) => {
                        this.configRegisterSuccess = response.data;
                    })
                    .catch((error) => {
                        console.log(error);
                    });
			});
        },
        getImageUrl: function (name) {
            //const currentTime = new Date().getTime();
            return Vue.bzbsConfig.bzbsBlobUrl + "/webconfig/Chanel/config/image/" + name + ".png";
        },

        isDateTimeBetween: function (startDateTime, endDateTime) {

            const dateTimeObj = new Date();
            const startDateTimeObj = new Date(startDateTime);
            const endDateTimeObj = new Date(endDateTime);

            return dateTimeObj.getTime() >= startDateTimeObj.getTime() && dateTimeObj.getTime() <= endDateTimeObj.getTime();
        }
    },
}
</script>
<style lang="scss">
    @import "@/style/base/component/modal/ModalFullScreen.scss";

    .modal-success-with-link {
        @extend %modal-base;

        .icon-wrapper {
            display: flex;
            justify-content: space-evenly;
        }
        .name {

            width: 140px;

            @media screen and (max-width: 325px) {
                width: 120px;
            }
        }

        .text-title {
            font-size: 1.2rem;
            font-weight: bold;
            text-decoration: underline;
            text-align: center;
            padding-top: 10px;
            padding-bottom: 20vh;
        }

        .img-icon {
            max-width: 100px;
            margin: auto;
            padding-bottom: 20px;
        }
    }
</style>
